import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

// Color presets
export const colorPresets = {
  electric: {
    name: "Electric",
    primary: "4 90% 58%",
    accent: "4 90% 58%",
    ring: "4 90% 58%",
    chart1: "4 90% 58%",
  },
  ocean: {
    name: "Ocean",
    primary: "217 91% 60%",
    accent: "217 91% 60%",
    ring: "217 91% 60%",
    chart1: "217 91% 60%",
  },
  forest: {
    name: "Forest",
    primary: "142 71% 45%",
    accent: "142 71% 45%",
    ring: "142 71% 45%",
    chart1: "142 71% 45%",
  },
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "dark");
  const [colorPreset, setColorPreset] = useState(() => localStorage.getItem("colorPreset") || "electric");

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(theme);
    localStorage.setItem("theme", theme);

    // Update theme-color meta tags to match the active theme
    const themeColor = theme === "dark" ? "#0a0a0a" : "#fafafa";
    const metaTags = document.querySelectorAll('meta[name="theme-color"]');
    if (metaTags.length > 0) {
      metaTags.forEach(tag => {
        tag.setAttribute("content", themeColor);
      });
    } else {
      const meta = document.createElement("meta");
      meta.setAttribute("name", "theme-color");
      meta.setAttribute("content", themeColor);
      document.head.appendChild(meta);
    }
  }, [theme]);

  useEffect(() => {
    const root = document.documentElement;
    const preset = colorPresets[colorPreset] || colorPresets.electric;
    
    root.style.setProperty("--primary", preset.primary);
    root.style.setProperty("--accent", preset.accent);
    root.style.setProperty("--ring", preset.ring);
    root.style.setProperty("--chart-1", preset.chart1);
    
    localStorage.setItem("colorPreset", colorPreset);
  }, [colorPreset]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  const cycleColorPreset = () => {
    const presets = Object.keys(colorPresets);
    const currentIndex = presets.indexOf(colorPreset);
    const nextIndex = (currentIndex + 1) % presets.length;
    setColorPreset(presets[nextIndex]);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, colorPreset, setColorPreset, cycleColorPreset }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
}
